import { ContextCodes } from "../../../pages/exploreHseContextsOldDeprecated/const/tabs";
import useAppTester from "../../../MobileMenu/hooks/useAppTester";
import { useHistory, useLocation } from "react-router-dom";
import { AuthXService } from "@brg/auth";
import { useMemo } from "react";

const INTUIT_MAIN_URL = 'https://ecole-intuit-lab.works/';
const INTUIT_PARIS_URL = 'https://paris.ecole-intuit-lab.works/';
const INTUIT_MARSEILLE_URL = 'https://marseille.ecole-intuit-lab.works/';
const INTUIT_SAOPAULO_URL = 'https://saopaulo.ecole-intuit-lab.works/';
const INTUIT_MUMBAI_URL = 'https://mumbai.ecole-intuit-lab.works/';
const INTUIT_KOLKATA_URL = 'https://kolkata.ecole-intuit-lab.works/';
const INTUIT_DUBAI_URL = 'https://dubai.ecole-intuit-lab.works/';
const INTUIT_SHANGHAI_URL = 'https://shanghai.ecole-intuit-lab.works/';

export const useFrenchContexts = () => {

    const {
        isFr,
        isMainContext,
        isIntuitParis,
        isIntuitMarseille,
        isIntuitSaopaulo,
        isIntuitMumbai,
        isIntuitKolkata,
        isIntuitDubai,
        isIntuitShanghai,
    } = useAppTester();

    const suffix = AuthXService.isAuthenticated() ? '?shouldLogin=true&saveLoginUrl=true' : '';
    const history = useHistory()
    const { pathname } = useLocation()

    const links = useMemo(() => ([
        {
            id: ContextCodes.creativeCity,
            active: isFr && isMainContext,
            content: 'main',
            linkTo: INTUIT_MAIN_URL + suffix,
            action: () => {
                if (isFr && isMainContext) {
                    history.push('/')
                    return;
                }
                window.open(INTUIT_MAIN_URL + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            externalLink: true,
        },
        {
            id: 'intuit_paris',
            active: isIntuitParis,
            content: 'paris',
            linkTo: INTUIT_PARIS_URL + suffix,
            action: () => {
                if (isIntuitParis) {
                    history.push('/')
                    return;
                }
                window.open(INTUIT_PARIS_URL + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            externalLink: true,
        },
        {
            id: 'intuit_marseille',
            active: isIntuitMarseille,
            content: 'marseille',
            linkTo: INTUIT_MARSEILLE_URL + suffix,
            action: () => {
                if (isIntuitMarseille) {
                    history.push('/')
                    return;
                }
                window.open(INTUIT_MARSEILLE_URL + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            externalLink: true,
        },
        {
            id: 'intuit_saopaulo',
            active: isIntuitSaopaulo,
            content: 'saopaulo',
            linkTo: INTUIT_SAOPAULO_URL + suffix,
            action: () => {
                if (isIntuitSaopaulo) {
                    history.push('/')
                    return;
                }
                window.open(INTUIT_SAOPAULO_URL + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            externalLink: true,
        },
        {
            id: 'intuit_mumbai',
            active: isIntuitMumbai,
            content: 'mumbai',
            linkTo: INTUIT_MUMBAI_URL + suffix,
            action: () => {
                if (isIntuitMumbai) {
                    history.push('/')
                    return;
                }
                window.open(INTUIT_MUMBAI_URL + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            externalLink: true,
        },
        {
            id: 'intuit_kolkata',
            active: isIntuitKolkata,
            content: 'kolkata',
            linkTo: INTUIT_KOLKATA_URL + suffix,
            action: () => {
                if (isIntuitKolkata) {
                    history.push('/')
                    return;
                }
                window.open(INTUIT_KOLKATA_URL + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            externalLink: true,
        },
        {
            id: 'intuit_dubai',
            active: isIntuitDubai,
            content: 'dubai',
            linkTo: INTUIT_DUBAI_URL + suffix,
            action: () => {
                if (isIntuitDubai) {
                    history.push('/')
                    return;
                }
                window.open(INTUIT_DUBAI_URL + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            externalLink: true,
        },
        {
            id: 'intuit_shanghai',
            active: isIntuitShanghai,
            content: 'shanghai',
            linkTo: INTUIT_SHANGHAI_URL + suffix,
                action: () => {
                if (isIntuitShanghai) {
                    history.push('/')
                    return;
                }
                window.open(INTUIT_SHANGHAI_URL + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            externalLink: true,
        },
        
    ]), [
        history,
        suffix,
        pathname,
        isFr,
        isMainContext,
        isIntuitParis,
        isIntuitMarseille,
        isIntuitSaopaulo,
        isIntuitMumbai,
        isIntuitKolkata,
        isIntuitDubai,
        isIntuitShanghai,
    ])

    return {
        links,
        modalSettings: {
            titleColor: '',
            title: ''
        }
    }
}import { ContextCodes } from "../../../pages/exploreHseContextsOldDeprecated/const/tabs";
import useAppTester from "../../../MobileMenu/hooks/useAppTester";
import { useHistory, useLocation } from "react-router-dom";
import { AuthXService } from "@brg/auth";
import { useMemo } from "react";

const INTUIT_MAIN_URL = 'https://ecole-intuit-lab.works/';
const INTUIT_PARIS_URL = 'https://paris.ecole-intuit-lab.works/';
const INTUIT_MARSEILLE_URL = 'https://marseille.ecole-intuit-lab.works/';
const INTUIT_SAOPAULO_URL = 'https://saopaulo.ecole-intuit-lab.works/';
const INTUIT_MUMBAI_URL = 'https://mumbai.ecole-intuit-lab.works/';
const INTUIT_KOLKATA_URL = 'https://kolkata.ecole-intuit-lab.works/';
const INTUIT_DUBAI_URL = 'https://dubai.ecole-intuit-lab.works/';
const INTUIT_SHANGHAI_URL = 'https://shanghai.ecole-intuit-lab.works/';

export const useFrenchContexts = () => {

    const {
        isFr,
        isMainContext,
        isIntuitParis,
        isIntuitMarseille,
        isIntuitSaopaulo,
        isIntuitMumbai,
        isIntuitKolkata,
        isIntuitDubai,
        isIntuitShanghai,
    } = useAppTester();

    const suffix = AuthXService.isAuthenticated() ? '?shouldLogin=true&saveLoginUrl=true' : '';
    const history = useHistory()
    const { pathname } = useLocation()

    const links = useMemo(() => ([
        {
            id: ContextCodes.creativeCity,
            active: isFr && isMainContext,
            content: 'main',
            linkTo: INTUIT_MAIN_URL + suffix,
            action: () => {
                if (isFr && isMainContext) {
                    history.push('/')
                    return;
                }
                window.open(INTUIT_MAIN_URL + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            externalLink: true,
        },
        {
            id: 'intuit_paris',
            active: isIntuitParis,
            content: 'paris',
            linkTo: INTUIT_PARIS_URL + suffix,
            action: () => {
                if (isIntuitParis) {
                    history.push('/')
                    return;
                }
                window.open(INTUIT_PARIS_URL + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            externalLink: true,
        },
        {
            id: 'intuit_marseille',
            active: isIntuitMarseille,
            content: 'marseille',
            linkTo: INTUIT_MARSEILLE_URL + suffix,
            action: () => {
                if (isIntuitMarseille) {
                    history.push('/')
                    return;
                }
                window.open(INTUIT_MARSEILLE_URL + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            externalLink: true,
        },
        {
            id: 'intuit_saopaulo',
            active: isIntuitSaopaulo,
            content: 'saopaulo',
            linkTo: INTUIT_SAOPAULO_URL + suffix,
            action: () => {
                if (isIntuitSaopaulo) {
                    history.push('/')
                    return;
                }
                window.open(INTUIT_SAOPAULO_URL + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            externalLink: true,
        },
        {
            id: 'intuit_mumbai',
            active: isIntuitMumbai,
            content: 'mumbai',
            linkTo: INTUIT_MUMBAI_URL + suffix,
            action: () => {
                if (isIntuitMumbai) {
                    history.push('/')
                    return;
                }
                window.open(INTUIT_MUMBAI_URL + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            externalLink: true,
        },
        {
            id: 'intuit_kolkata',
            active: isIntuitKolkata,
            content: 'kolkata',
            linkTo: INTUIT_KOLKATA_URL + suffix,
            action: () => {
                if (isIntuitKolkata) {
                    history.push('/')
                    return;
                }
                window.open(INTUIT_KOLKATA_URL + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            externalLink: true,
        },
        {
            id: 'intuit_dubai',
            active: isIntuitDubai,
            content: 'dubai',
            linkTo: INTUIT_DUBAI_URL + suffix,
            action: () => {
                if (isIntuitDubai) {
                    history.push('/')
                    return;
                }
                window.open(INTUIT_DUBAI_URL + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            externalLink: true,
        },
        {
            id: 'intuit_shanghai',
            active: isIntuitShanghai,
            content: 'shanghai',
            linkTo: INTUIT_SHANGHAI_URL + suffix,
                action: () => {
                if (isIntuitShanghai) {
                    history.push('/')
                    return;
                }
                window.open(INTUIT_SHANGHAI_URL + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            externalLink: true,
        },
        
    ]), [
        history,
        suffix,
        pathname,
        isFr,
        isMainContext,
        isIntuitParis,
        isIntuitMarseille,
        isIntuitSaopaulo,
        isIntuitMumbai,
        isIntuitKolkata,
        isIntuitDubai,
        isIntuitShanghai,
    ])

    return {
        links,
        modalSettings: {
            titleColor: '',
            title: ''
        }
    }
}